import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/San-Francisco.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              TekRevol At The Pinnacle Of App Development Companies San
              Francisco
            </h2>
            <p>
              San Francisco is the center of booming startups from a variety of
              industries. Giants like Stripe, Dropbox, Reddit, Airbnb, Docker,
              Gitlab, and Firebase are all seed accelerators that empower
              startups in San Francisco.
            </p>
            <p>
              In terms of opportunity, it doesn’t matter if your expertise is in
              Fin-Tech, SaaS product development, or rental businesses. There’s
              an opportunity for you to leverage San Francisco app development
              through these accelerators.
            </p>
            <p>
              Our app development services in San Francisco include a team of
              skilled project managers assigned to each project to ensure
              milestones are completed within the agreed-upon timeline while
              maintaining top-notch quality.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
